import PropTypes from 'prop-types';
import { Body3 } from '../themes/typography';
import '../styles/animation/LoadingSpinner.css';

export default function LoadingSpinner({
    message = 'Loading events...'
}) {
    return (
        <div className="loading-spinner-container">
            <div className="loading-spinner-wrapper">
                <div className="loading-spinner"></div>
                <div className="loading-spinner-inner"></div>
            </div>
            <div className="loading-spinner-message">
                <Body3>{message}</Body3>
            </div>
        </div>
    );
};

LoadingSpinner.propTypes = {
    message: PropTypes.string
};